import React from 'react'
import { ContentBlock } from 'components/ContentBlock'
import { DataTable } from 'components//DataTable'
import { creditCustomer_orders, creditCustomer_orderItems } from '../tableColumns'
import { useTranslation } from 'react-i18next'
import useLocale from 'hooks/useLocale'

const Creditcard = ({ data }) => {
	const [t] = useTranslation()
	const locale = useLocale()
	return(
		<ContentBlock>
			<DataTable
				isInsideContentBlock
				label={t('closing_section.sub_sections.credit_client')}
				columns={creditCustomer_orders(t, locale)}
				data={data.creditClientOrders || []}
				SubComponent={({ original }) => {
					return (
						<DataTable
							columns={creditCustomer_orderItems(t, locale)}
							data={original.items || []}
							sortable={false}
						/>
					)
				}}
			/>
		</ContentBlock>
	)
}

export default Creditcard
